import { render, staticRenderFns } from "./LoadedPrice.vue?vue&type=template&id=f4a22bac&"
import script from "./LoadedPrice.vue?vue&type=script&lang=js&"
export * from "./LoadedPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports